import React from 'react'
import './css/WSSecondRow.css'
import db from '../firebase.js'
import {useState,useEffect} from "react"

export const Ws2ParaInfo = () => {


    let [ws2,setWs2]=useState({})
    useEffect(()=>{
        db.collection("Realtime").doc("WS 2").onSnapshot(doc=>{
            setWs2(doc.data())
 

        })
    },[])

    return (
        <div className="graph-parameters-info">

        <div className="performance">
          <div style={{fontSize:"80%"}}>
            Performance
              </div>
          <div className="value" style={{fontSize:"80%"}}>{ws2.performance} </div>

        </div>
        <div className="availability">
          <div style={{fontSize:"80%"}}>
            Availability
              </div>
          <div className="value" style={{fontSize:"80%"}}>{ws2.availability}</div>

        </div>

        <div className="quality">
          <div style={{fontSize:"80%"}}>
            Quality
            </div>
          <div className="value" style={{fontSize:"80%"}}>{ws2.quality}</div>
        </div>
        <div className="oee">
          <div>
            OEE
            </div>
          <div className="value" style={{fontSize:"80%"}}>{ws2.oee}</div>

        </div>

      </div>
    )
}
